import { PriceItem } from '../../../types/event.types';

export interface FormData {
    id?: string;
    organizerId: string;
    organizerContact?: string;
    title: string;
    description?: string;
    date?: string;
    time?: string;
    endTime?: string;
    location?: string;
    locationName?: string;
    latitude?: number;
    longitude?: number;
    geohash?: string;
    timezone: string; // IANA timezone (ex: 'Asia/Colombo')
    isRecurring: boolean;
    startDate?: string;
    startTime?: string;
    endDate?: string;
    endType: 'date' | 'occurrences';
    occurrences?: number;
    frequency: 'daily' | 'weekly';
    weekDays: string[];
    daySchedules?: Record<string, { start: string; end: string }> | null; // Per-day time overrides
    tags: string[];
    prices: PriceItem[];
    ticketingUrl?: string;
    isLocationNameManuallySet?: boolean;
    image: string;
    status: 'draft' | 'active' | 'cancelled';
    
    // Nouveau champ pour gérer la modification d'occurrence individuelle
    isEditingOccurrence?: boolean;
    seriesId?: string; // Pour conserver la référence à la série lors de l'édition d'occurrence
}


export const initialFormData: FormData = {
    organizerId: '',
    organizerContact: '',
    title: '',
    description: '',
    date: '',
    time: '',
    endTime: '',
    location: '',
    locationName: '',
    isLocationNameManuallySet: false,
    latitude: undefined,
    longitude: undefined,
    timezone: '', // Will be auto-detected from location
    tags: [],
    prices: [],
    ticketingUrl: '',
    status: 'draft',
    image: '',
    
    // Default values for recurring events
    isRecurring: false,
    frequency: 'weekly',
    startDate: '',
    startTime: '',
    endDate: '',
    endType: 'date',
    occurrences: 1,
    weekDays: [],
    daySchedules: null,

    // Default values for occurrence editing
    isEditingOccurrence: false,
    seriesId: undefined,
};

export const REQUIRED_FOR_DRAFT = ['title', 'organizerId'];

export const REQUIRED_FOR_PUBLISH = [
  ...REQUIRED_FOR_DRAFT,
  'description',
  'location',
  'locationName',
  // Pour les événements ponctuels
  'date',
  'time',
  // endTime n'est plus obligatoire - sera calculé automatiquement (+1h) si non fourni
  // Pour les événements récurrents
  'startDate',
  'startTime',
  // endTime n'est plus obligatoire - sera calculé automatiquement (+1h) si non fourni
  'frequency',
  'weekDays' // Si frequency === 'weekly'
];
